import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommonService } from 'src/app/Service/Common.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { LoginService } from 'src/app/Service/login.service';
import { UserDetailsViewModel } from 'src/app/ViewModel/UserDetailsModel';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  public isInternalUser = true;
  public isSubmitted = false;
  public currentYear: number = new Date().getFullYear();
  isPopupVisible = false;

  public loginForm: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  });

  constructor(private commonService: CommonService,
    private dialog: MatDialog,
    private router: Router, private _notificationService: NotificationService, private encryptDecryptService: EncryptDecryptService, private loginService: LoginService) { }

  ngOnInit() {
    this.isSubmitted = false;

    if (this.commonService.hasJWT()) {
      this.router.navigate(['/dashboard']);
    }
  }
  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
  }
  public onTabClick(event: MatTabChangeEvent) {
    if (event.tab.textLabel === "Employee")
      this.isInternalUser = true;
    else
      this.isInternalUser = false;
  }

  getFormValue(controlName: string): any {
    return this.loginForm.get(controlName)?.value;
  }

  public onSubmit(): any {
    this.isSubmitted = true;

    if (!this.isInternalUser && this.loginForm.invalid) {
      this.isSubmitted = false;
      return false;
    }

    if (this.isInternalUser) {
      this.loginService.InternalMemberLogin();
    }
    else {
      let user = {
        username: this.getFormValue("username"),
        password: this.encryptDecryptService.encrypt(this.getFormValue("password")),
        isInternalUser: this.isInternalUser,
      };

      this.loginService.ExternalMemberLogin(user).subscribe((data: StandardOutputModel) => {
        if (data.successCode === 200) {
          this.GetCurrentUserDetails({ memberId: data.result, isInternal: this.isInternalUser, isLoginTime: true });
        }
        else if(data.successCode === 500){
          this.isSubmitted = false;
          this.loginForm.get('password')?.setValue('');
          let retryCount:number = +data.result;
          if(retryCount >=5)
          {
            this._notificationService.showPopup("Your account is locked. To unlock it, please contact admin.", "Warning");
          }
          else{
            let remainingAttempt:number  = 5 - retryCount;
            if(remainingAttempt <=3){
              this._notificationService.showPopup(remainingAttempt + " Attempt(s) remaining", "Warning");
            }
            else{
              this._notificationService.showPopup(data.successMessage, "Warning");
            }
          }
        }
        else {
          this.isSubmitted = false;
          this.loginForm.get('username')?.setValue('');
          this.loginForm.get('password')?.setValue('');
          this._notificationService.showPopup(data["successMessage"], "Warning");
        }
      });
    }
  }

  public GetCurrentUserDetails(user: { memberId: string; isInternal: boolean; isLoginTime: boolean; }) {
    this.loginService.GetCurrentUserDetails(user).subscribe((data: UserDetailsViewModel[]| any) => {
      if (data["successCode"] === 200) {
        let isDuplicateLogin = data["isDuplicateLogin"];
        this.commonService.setCurrentUserProfileCard(data);

        if (isDuplicateLogin === true) {
          this._notificationService.showPopup('Your login account is used in another device. The session in that device has been closed', "Warning").then(
            x => {
              this.router.navigate(this.commonService.redirectUserToPRAddComments ? ['/peer-review/review-add-comments'] : ['/dashboard']);
            }
          );
        }
        else {
          this.router.navigate(this.commonService.redirectUserToPRAddComments ? ['/peer-review/review-add-comments'] : ['/dashboard']);
        }
      }
      else {
        this.isSubmitted = false;
        this.loginForm.get('username')?.setValue('');
        this.loginForm.get('password')?.setValue('');
        this._notificationService.showPopup(data["successMessage"], "Warning");
      }
    });
  }

  public forgetPwd() {
    const dialogRef = this.dialog.open(ForgetPasswordComponent, {
      panelClass: 'mat-dialog-forget',
      width: '45%'
    });
  }
}
